function jcMoveNewsletterBar() {
  var panels = document.querySelectorAll('.group-block-content.layout-panel-flex.layout-panel-flex--column');
  var target = null;
  panels.forEach(function (p) {
    if (p.textContent.indexOf('Join our email list') !== -1) target = p;
  });
  if (!target) return;

  var emailBlock = document.querySelector('.email-signup-block');
  if (!emailBlock) return;

  if (target.contains(emailBlock)) return;

  target.classList.add('jc-newsletter-row');
  target.appendChild(emailBlock);
}

document.addEventListener('DOMContentLoaded', jcMoveNewsletterBar);

var jcFooterObserver = new MutationObserver(function () {
  jcMoveNewsletterBar();
});
jcFooterObserver.observe(document.body, { childList: true, subtree: true });